import React from 'react'
import { Link } from 'react-router-dom'
import {
  Illustration,
  IllustrationChoices,
} from '../../../../components/common/Illustration'
import { Icon, IconChoices } from '../../../../components/common/Icon'
import { reverseUrl } from '../../../../navigation/reverseUrl'
import { SocietyTypes } from '../../../../types/society-type'
import { SocietyType } from '../SocietyType'
import { theme } from '../../../../theme/theme'
import { cn } from '../../../../helpers/utils'

interface CreateSocietyTypeCardProps {
  title: string
  type: SocietyType
  illustration: IllustrationChoices
  className?: string
}

export const CreateSocietyTypeCard = ({
  title,
  type,
  illustration,
  className,
}: CreateSocietyTypeCardProps): JSX.Element => {
  const getSocietyType = (): SocietyTypes => {
    switch (type) {
      case SocietyType.HOUSING_COOPERATIVE:
        return SocietyTypes.HOUSING_COOPERATIVE
      case SocietyType.HOMEOWNERS_ASSOCIATION:
        return SocietyTypes.HOME_OWNERS_ASSOCIATION
      case SocietyType.NEIGHBOURHOOD:
        return SocietyTypes.NEIGHBOURHOOD
      case SocietyType.APARTMENT_BUILDING:
        return SocietyTypes.APARTMENT_BUILDING
      default:
        return SocietyTypes.HOUSING_COOPERATIVE_CONSTRUCTION
    }
  }

  const societyTypeDisplayName = getSocietyType()

  return (
    <Link
      to={reverseUrl('create-society')}
      state={{ societyTypeDisplayName }}
      className={cn(
        'block flex flex-col justify-between rounded-lg shrink-0 border border-neutral-80 text-center shadow p-4',
        className
      )}
    >
      <div className="flex h-full flex-col justify-between space-y-5">
        <div className="flex items-center justify-center h-[170px]">
          <Illustration illustrationChoice={illustration} />
        </div>
        <div className="flex justify-between gap-4">
          <p style={theme.textVariants.base} className="self-start">
            {title}
          </p>
          <Icon icon={IconChoices.ARROW} />
        </div>
      </div>
    </Link>
  )
}
